var map = {
	"./BigBrain.jpg": 78,
	"./Boardless.jpg": 79,
	"./Corona.jpg": 80,
	"./HealthyU.jpg": 81,
	"./ParticleCatch.jpg": 82,
	"./Physics Learner.jpg": 83,
	"./Rick and Morty Chess.jpg": 84,
	"./RideOn.jpg": 85,
	"./Shifter.jpg": 86,
	"./Smile.jpg": 87,
	"./TOpark.jpg": 88,
	"./Youuuurl.jpg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;